module.exports = __webpack_public_path__ + "static/logo-5b1f547d764ab16c9761c2538fbb1877.png";